import activeDialog from './active-dialog.json';
import aiAgent from './aiAgent.json';
import assessments from './assessments.json';
import attributeGroups from './attributeGroups.json';
import attributes from './attributes.json';
import audioAudit from './audioAudit.json';
import auth from './auth.json';
import behaviorFactors from './behaviorFactors.json';
import betaFeatures from './betaFeatures.json';
import billing from './billing.json';
import chat from './chat.json';
import checklists from './checklists.json';
import coaching from './coaching.json';
import common from './common.json';
import expertReport from './expert-report.json';
import generalSettings from './generalSettings.json';
import copilot from './copilot.json';
import dialogs from './dialogs.json';
import downloadTemplates from './downloadTemplates.json';
import error from './error.json';
import integrations from './integrations.json';
import knowledge from './knowledge.json';
import knowledgeSets from './knowledgeSets.json';
import knowledgeSources from './knowledgeSources.json';
import kmEntities from './kmEntities.json';
import ontology from './ontology.json';
import pipelines from './pipelines.json';
import predictiveModels from './predictiveModels.json';
import profile from './profile.json';
import records from './records.json';
import roles from './roles.json';
import rules from './rules.json';
import runs from './runs.json';
import samples from './samples.json';
import stopWords from './stopWords.json';
import tablePresets from './tablePresets.json';
import terms from './terms.json';
import anonymizerConfig from './anonymizerConfig.json';
import employees from './employees.json';
import qualityDashboard from './qualityDashboard.json';
import renessansDashboard from './renessansDashboard.json';
import missellingDashboard from './missellingDashboard.json';
import strategist from './strategist.json';
import themes from './themes.json';
import users from './users.json';
import userUrlLog from './userUrlLog.json';

const langs = {
  audioAudit,
  anonymizerConfig,
  employees,
  aiAgent,
  auth,
  behaviorFactors,
  betaFeatures,
  billing,
  coaching,
  common,
  dialogs,
  downloadTemplates,
  error,
  chat,
  activeDialog,
  records,
  rules,
  attributes,
  attributeGroups,
  checklists,
  expertReport,
  generalSettings,
  assessments,
  profile,
  users,
  roles,
  copilot,
  integrations,
  terms,
  stopWords,
  tablePresets,
  knowledge,
  knowledgeSets,
  knowledgeSources,
  predictiveModels,
  kmEntities,
  ontology,
  samples,
  pipelines,
  qualityDashboard,
  renessansDashboard,
  missellingDashboard,
  strategist,
  runs,
  themes,
  userUrlLog,
};

export const enLangs = langs;
